/*
 * Copyright (c) Worldline 2023.
 */

export const ExternalSessionStatus = {
    init: 'INIT',
    completed: 'COMPLETED',
    canceled: 'CANCELED',
    error: 'ERROR',
    resumeEmailKo: 'RESUME_EMAIL_KO'
}